import React, { Component } from 'react';
import { Card, Button, Divider } from 'antd';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Link } from 'react-router';
import { injectIntl, FormattedMessage } from 'react-intl';
import { themeColors } from '../../../constants/themes';
import { theme } from '../../../constants';
import IconSvg from '../../common/IconSvg';
import AddOnsCheckboxes from './AddOnsCheckboxes';
import { RowFlex } from '../../common/FlexStyle';
import eNums from '../../../constants/enums';
import Checkout from '../../Checkout';

const CustomCard = styled(Card)`
  margin: 0 5px;
  border-radius: 8px;
  border: ${props => (props.selected ? `1px solid ${themeColors.darkBlue}` : '')};
  box-shadow: 0 1px 6px 0 rgba(71, 69, 136, 0.11);
  ${({ zindex }) => zindex && 'z-index: 1;'}
  :hover {
    box-shadow: 0 1px 6px 0 rgba(71, 69, 136, 0.11);
  }
  & .ant-card-body {
    padding: 15px 10px;
    position: relative;
  }
`;
const CloseButtonContainer = styled.div`
  width: 100%;
  position: relative;
  & > span {
    position: absolute;
    right: 0;
    top: 0;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AdditionalInfoWrapper = styled.div`
  padding: 5px 0;
  font-size: ${theme.fontSize.medium};
`;
const RequiredFields = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 0 10px;
  font-size: ${theme.fontSize.small};
`;

const FlexibleInfoWrapper = ({ children }) => (
  <div
    css={css`
      height: 330px;
      display: flex;
      flex-direction: column;
      min-height: 0;
    `}
  >
    <div
      css={css`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
      `}
    >
      {children}
    </div>
  </div>
);

@inject('settingsStore')
@injectIntl
@observer
class SubscriptionPlanCard extends Component {
  constructor(props) {
    super(props);
    const activeTypes = [];
    this.state = {
      poppedCardAddOns:
        props.settingsStore.subscription
          .planById(props.displayedPlansOnboarding[props.planStartingIndex].id)
          .allowedAddOnPlans.map(({ id, cost, plans, name, typeId }) => {
            let isSelected = true;
            if (activeTypes[typeId]) {
              isSelected = false;
            } else {
              activeTypes[typeId] = true;
            }
            return {
              id,
              isSelected,
              cost,
              plans,
              name,
              typeId,
            };
          }) || [],
      plan: props.displayedPlansOnboarding[props.planStartingIndex],
      htmlID: `tm-${this.props.displayedPlansOnboarding[props.planStartingIndex].id}-card`,
      selected:
        this.props.currentPlanId ===
        this.props.displayedPlansOnboarding[props.planStartingIndex].id,
      customIndex: props.planStartingIndex,
    };
    this.toggleAddOn = this.toggleAddOn.bind(this);
  }

  setCustomSelectedPlan = customPlanIndex => {
    this.activeTypes = [];
    this.setState({
      htmlID: `tm-${this.props.displayedPlansOnboarding[customPlanIndex].id}-card`,
      selected:
        this.props.currentPlanId === this.props.displayedPlansOnboarding[customPlanIndex].id,
      plan: this.props.displayedPlansOnboarding[customPlanIndex],
      customIndex: customPlanIndex,
      poppedCardAddOns:
        this.props.settingsStore.subscription
          .planById(this.props.displayedPlansOnboarding[customPlanIndex].id)
          .allowedAddOnPlans.map(({ id, cost, plans, name, typeId }) => {
            let isSelected = true;
            if (this.activeTypes[typeId]) {
              isSelected = false;
            } else {
              this.activeTypes[typeId] = true;
            }
            return {
              id,
              isSelected,
              cost,
              plans,
              name,
              typeId,
            };
          }) || [],
    });
  };

  toggleAddOn(newValue, addOnId) {
    const { poppedCardAddOns } = this.state;
    const {
      settingsStore: {
        subscription: { addOnById },
      },
    } = this.props;
    const thisAddOnCategory = addOnById(addOnId);
    const newState =
      newValue === true
        ? {
            poppedCardAddOns: poppedCardAddOns.map(addOn => {
              return {
                ...addOn,
                // only one addOnPlan from a given type can be active
                isSelected: addOn.id === addOnId ? true : !thisAddOnCategory.hasPlan(addOn.id),
              };
            }),
          }
        : {
            poppedCardAddOns: poppedCardAddOns.map(addOn => {
              return {
                ...addOn,
                isSelected: addOn.id === addOnId ? false : addOn.isSelected,
              };
            }),
          };
    this.setState(newState);
  }

  render() {
    const {
      monthlyPayment,
      upgradePlan,
      selectedPlanCost,
      poppedOver,
      closeCard = () => {},
      requiredData = [],
      intl,
      isJA,
      disableUpgrade,
      recommendedPlanId,
      openOtherPlanCard,
      clickedPlanBCR,
      isNonApi,
      displayedPlansOnboarding,
      hoveringCardVisible,
      billableAccounts,
      planStartingIndex,
      currentPlanId,
      settingsStore: {
        subscription: { trialEligible },
      },
    } = this.props;

    const {
      poppedCardAddOns,
      plan,
      plan: { monthlyCostUnreduced },
      selected,
      htmlID,
      customIndex,
    } = this.state;

    const needsMoreInfo = requiredData.some(data => !data.value);
    const cost = monthlyPayment ? plan.monthlyCost : plan.annualCost;

    const requiredOptionSelected = poppedCardAddOns.length
      ? poppedCardAddOns.some(({ isSelected }) => isSelected)
      : true;

    // styles for nonApi and Api plans
    // default colors
    const planStyle = {
      color: '#2E3849',
      limitedColor: '#FF3852',
      buttonBg: 'transparent',
      buttonColor: '#0070BA',
    };
    if (isNonApi) {
      planStyle.badgeBG = '#FFAA2A';
      planStyle.badgeSide = '#D08006';
      planStyle.listIcon = '/assets/icons/plan_star_grey.svg';
    } else {
      planStyle.badgeBG = '#00A5F2';
      planStyle.badgeSide = '#006D9F';
      planStyle.listIcon = '/assets/icons/plan_star_orange.svg';
    }
    let buttonMessage;
    if (currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_TRAIL) {
      buttonMessage = intl.formatMessage({ id: 'subscription.payNow' });
    } else {
      buttonMessage = intl.formatMessage({ id: 'subscription.updatePlan' });
    }

    return (
      <div onClick={e => poppedOver && e.stopPropagation()} id={htmlID}>
        <CustomCard
          selected={selected}
          popped={poppedOver ? 1 : 0}
          zindex="1"
          clickedplanbcr={clickedPlanBCR}
          className="tm-plan-initial-pos"
          style={planStyle}
        >
          {poppedOver && (
            <CloseButtonContainer>
              <IconSvg type="x" onClick={closeCard} size={10} />
            </CloseButtonContainer>
          )}
          <RowFlex
            css={css`
              position: absolute;
              top: -11px;
              left: 50%;
              transform: translateX(-50%);
              background: ${planStyle.badgeBG};
              color: #fff;
              width: 60%;
              height: 27px;
              align-items: center;
              justify-content: center;
              border-radius: 0 0 8px 8px;
              text-align: center;

              &::before,
              &::after {
                content: '';
                display: block;
                position: absolute;
                width: 9px;
                height: 11px;
                top: 0;
              }

              &::before {
                left: -9px;
                background: linear-gradient(
                  to bottom right,
                  transparent 0%,
                  transparent 50%,
                  ${planStyle.badgeSide} 50%,
                  ${planStyle.badgeSide} 100%
                );
              }

              &::after {
                right: -9px;
                background: linear-gradient(
                  to bottom left,
                  transparent 0%,
                  transparent 50%,
                  ${planStyle.badgeSide} 50%,
                  ${planStyle.badgeSide} 100%
                );
              }

              & > span {
                font-family: Heebo-Bold;
                font-size: 14px;
                margin: 0 5px;
              }
              & > div {
                background: #fff;
                width: 14px;
                height: 14px;
                line-height: 14px;
                border-radius: 9px;
              }
            `}
          >
            <span>custom plan</span>
          </RowFlex>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '44px',
            }}
          >
            <select
              id="select_plan_custom"
              onChange={e => this.setCustomSelectedPlan(e.target.value)}
            >
              {displayedPlansOnboarding
                .filter(
                  planB =>
                    planB.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
                    planB.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY &&
                    planB.maxListedItems > 10000,
                )
                .map((planB, index) => {
                  return (
                    <option value={index + planStartingIndex} key={`plan-card-${planB.id}`}>
                      {planB.name}
                    </option>
                  );
                })}
            </select>
          </div>
          <div style={{ fontFamily: 'Heebo-Bold', textAlign: 'center', lineHeight: '1.4' }}>
            <span style={{ fontSize: '24px' }}>${cost}</span>
            <span style={{ fontSize: '12px', opacity: '50%' }}>
              {' '}
              /{monthlyPayment ? 'mo' : 'year'}
            </span>
          </div>
          <div
            style={{
              fontFamily: 'Heebo-Regular',
              textAlign: 'center',
              fontSize: '14px',
              lineHeight: '1.2',
              color: planStyle.limitedColor,
            }}
          >
            <span>
              $<del>{monthlyCostUnreduced}</del>&nbsp;{isNonApi ? '30%' : '50%'} off
            </span>
          </div>
          <div
            style={{
              color: `${plan.isHighlyRecommended ? planStyle.limitedColor : 'red'}`,
              fontSize: '11px',
              textAlign: 'center',
              lineHeight: '1.2',
            }}
          >
            *Limited time offer
          </div>
          <Divider style={{ margin: '1em 0' }} />
          <FlexibleInfoWrapper>
            <div
              className="scroll-1"
              css={css`
                height: 180px;
                overflow-y: auto;
                flex-grow: 1;
                min-height: 0;
                ul {
                  font-size: ${theme.fontSize.medium};
                  list-style: none;

                  li {
                    display: flex;
                    margin-bottom: 5px;

                    &::before{
                      content:"";
                      display:inline-block;
                      height: 20px;
                      width: 20px;
                      margin-right: 6px;
                      background-image: url('${planStyle.listIcon}');
                      background-size: cover;
                    }
                  }
                }
              `}
              dangerouslySetInnerHTML={{ __html: plan.description }}
            />
            {poppedOver && recommendedPlanId && (
              <Link
                onClick={() => {
                  closeCard();
                  openOtherPlanCard(null, recommendedPlanId);
                }}
              >
                <IconSvg type="space-ship" size={20} /> Click here to check out a better plan (with
                BIFM and Catalog included)
              </Link>
            )}
            {poppedOver && !selected && needsMoreInfo && (
              <AdditionalInfoWrapper>
                <span style={{ color: themeColors.pink }}>*</span>
                <FormattedMessage id="subscription.needMoreInfo" />
                <RequiredFields>
                  {requiredData.map(data =>
                    !data.value ? (
                      <span key={data.type}>
                        <FormattedMessage id={`userProfile.${data.type}`} />
                      </span>
                    ) : null,
                  )}
                </RequiredFields>
              </AdditionalInfoWrapper>
            )}
            {poppedOver && !selectedPlanCost && !needsMoreInfo && (
              <AdditionalInfoWrapper>
                <span style={{ color: themeColors.pink }}>*</span>
                <FormattedMessage
                  id="subscription.firstPayment"
                  values={{ monthlyCost: `$ ${plan.monthlyCost}` }}
                />
              </AdditionalInfoWrapper>
            )}
            {poppedOver && !selected && !needsMoreInfo && (
              <AdditionalInfoWrapper>
                <AddOnsCheckboxes addOns={poppedCardAddOns} toggleAddOn={this.toggleAddOn} />
              </AdditionalInfoWrapper>
            )}
            {!selected && !hoveringCardVisible && (
              <Row>
                <Col>
                  <Button
                    id="btn_plan_custom"
                    disabled={disableUpgrade || !requiredOptionSelected}
                    style={{
                      background: planStyle.buttonBg,
                      fontSize: isJA ? '10px' : '14px',
                      borderColor: '#0070BA',
                      color: '#0070BA',
                      borderRadius: '12px',
                      fontFamily: 'Heebo',
                    }}
                    onClick={() => upgradePlan(customIndex, plan.id)}
                  >
                    {trialEligible ? 'Start with 1$' : buttonMessage}
                  </Button>
                  {trialEligible && (
                    <span
                      css={css`
                        text-align: center;
                        position: relative;
                        top: 5px;
                      `}
                    >
                      7 days trial
                    </span>
                  )}
                </Col>
              </Row>
            )}
            {hoveringCardVisible && billableAccounts.length === 0 && (
              <Checkout
                afterConnect={() => {
                  upgradePlan(plan.id, poppedCardAddOns);
                }}
              />
            )}
            {hoveringCardVisible && billableAccounts.length !== 0 && (
              <Row marginTop>
                <Button
                  id="btn_agree_plan_custom"
                  disabled={disableUpgrade || !requiredOptionSelected}
                  style={{
                    background: planStyle.buttonBg,
                    fontSize: isJA ? '10px' : '14px',
                    borderColor: planStyle.badgeBG,
                    color: planStyle.buttonColor,
                    borderRadius: '12px',
                    fontFamily: 'Heebo',
                  }}
                  onClick={() => upgradePlan(plan.id, poppedCardAddOns)}
                >
                  {intl.formatMessage({ id: 'subscription.updatePlan' })}
                </Button>
              </Row>
            )}
          </FlexibleInfoWrapper>
        </CustomCard>
      </div>
    );
  }
}

SubscriptionPlanCard.propTypes = {
  intl: PropTypes.object,
  upgradePlan: PropTypes.func,
  closeCard: PropTypes.func,
  monthlyPayment: PropTypes.bool,
  isJA: PropTypes.bool,
  selectedPlanCost: PropTypes.number,
  requiredData: PropTypes.array,
  settingsStore: PropTypes.object,
  recommendedPlanId: PropTypes.string,
  openOtherPlanCard: PropTypes.func,
};

export default SubscriptionPlanCard;
